import React from "react";

const TemarioDiplomaturaMedicinaAdicciones = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Introducción, presentación, icebreakers, modalidad, evaluación y titulación"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Presentaciones (Icebreakers)"}</span></li>
                <li><span className="fw-light">{"Modalidad educativa: aprendizaje, relearning, participación"}</span></li>
                <li><span className="fw-light">{"Evaluación"}</span></li>
                <li><span className="fw-light">{"Aprobación"}</span></li>
            </ul>
            <br /><br />
            <b>{"Importancia del tema, impacto de adicciones en ámbitos laborales, sociales"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Generalidades"}</span></li>
                <li><span className="fw-light">{"Aspectos epidemiológicos del consumo de drogas en las Américas"}</span></li>
                <li><span className="fw-light">{"Impacto en el ámbito laboral"}</span></li>
                <li><span className="fw-light">{"Certificaciones"}</span></li>
                <li><span className="fw-light">{"Impacto en el ámbito familiar"}</span></li>
                <li><span className="fw-light">{"Impacto en la vida personal"}</span></li>
            </ul>
            <br /><br />
            <b>{"Conceptualización de las drogas y las adicciones"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Conceptos básicos: drogodependencia y uso problemático"}</span></li>
                <li><span className="fw-light">{"Clasificación de las drogas"}</span></li>
                <li><span className="fw-light">{"Psicología del drogodependiente"}</span></li>
                <li><span className="fw-light">{"Factores de riesgo y de protección"}</span></li>
            </ul>
            <br /><br />
            <b>{"La psicobiología de las adicciones"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Conceptos básicos sobre la adicción"}</span></li>
                <li><span className="fw-light">{"La adicción conductual o la conducta adictiva"}</span></li>
                <li><span className="fw-light">{"Las adicciones conductuales frente a las adicciones de sustancias"}</span></li>
                <li><span className="fw-light">{"La adicción y la salud mental"}</span></li>
                <li><span className="fw-light">{"La adicción y la personalidad"}</span></li>
                <li><span className="fw-light">{"La adicción y el cerebro (aspectos neurobiológicos)"}</span></li>
                <li><span className="fw-light">{"Comorbilidad Psiquiátrica o Patología Dual"}</span></li>
            </ul>
            <br /><br />
            <b>{"Daños producidos por la adicción"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Adicción en términos generales"}</span></li>
                <li><span className="fw-light">{"El sistema de recompensa cerebral"}</span></li>
                <li><span className="fw-light">{"Daños comunes de la adicción"}</span></li>
                <li><span className="fw-light">{"El juego patológico"}</span></li>
                <li><span className="fw-light">{"Aspectos legales: daños a sí mismo y a terceros"}</span></li>
                <li><span className="fw-light">{"Convenciones internacionales"}</span></li>
            </ul>
            <br /><br />
            <b>{"Abordaje terapéutico"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Tipos de abordaje"}</span></li>
                <li><span className="fw-light">{"Dispositivos de tratamiento"}</span></li>
                <li><span className="fw-light">{"El tratamiento en la interdisciplina"}</span></li>
                <li><span className="fw-light">{"Conceptualización de políticas públicas en drogas"}</span></li>
                <li><span className="fw-light">{"Prevención"}</span></li>
            </ul>
            <br /><br />
            <b>{"El alcohol"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"El consumo de alcohol"}</span></li>
                <li><span className="fw-light">{"Problemas asociados y efectos del consumo de alcohol: efectos agudos y crónicos; síndrome de abstinencia"}</span></li>
                <li><span className="fw-light">{"Problemas derivados del consumo del alcohol: patrones o conductas de riesgo en poblaciones específicas (adolescencia, embarazo, etc.)"}</span></li>
                <li><span className="fw-light">{"Abordaje terapéutico del alcoholismo: modelo terapéutico, comunidad Alcohólicos Anónimos (AA)"}</span></li>
                <li><span className="fw-light">{"El alcohol según el manual diagnóstico y estadístico de los trastornos mentales"}</span></li>
            </ul>
            <br /><br />
            <b>{"El tabaco"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Introducción histórica"}</span></li>
                <li><span className="fw-light">{"Componentes del tabaco y humo de tabaco"}</span></li>
                <li><span className="fw-light">{"Efectos del consumo de tabaco para la salud"}</span></li>
                <li><span className="fw-light">{"La aparición de la conducta adictiva"}</span></li>
                <li><span className="fw-light">{"Abordaje terapéutico y prevención del tabaquismo"}</span></li>
                <li><span className="fw-light">{"El tabaquismo según el manual diagnóstico y estadístico de los trastornos mentales"}</span></li>
            </ul>
            <br /><br />
            <b>{"Los estimulantes"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Los estimulantes"}</span></li>
                <li><span className="fw-light">{"Xantinas"}</span></li>
                <li><span className="fw-light">{"Derivados de la hoja de coca: pasta base, clorhidrato de cocaína y crack"}</span></li>
                <li><span className="fw-light">{"Anfetaminas"}</span></li>
                <li><span className="fw-light">{"Los estimulantes según el manual diagnóstico y estadístico de los trastornos mentales"}</span></li>
            </ul>
            <br /><br />
            <b>{"El cannabis"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Cannabis: conceptos generales, formas de consumo, tipos de cannabinoides y sistema cannabinoide endógeno"}</span></li>
                <li><span className="fw-light">{"Efectos agudos y crónicos del consumo de cannabis"}</span></li>
                <li><span className="fw-light">{"Abordaje terapéutico"}</span></li>
                <li><span className="fw-light">{"El cannabis según el manual diagnóstico y estadístico de los trastornos mentales"}</span></li>
            </ul>
            <br /><br />
            <b>{"Los alucinógenos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Sustancias alucinógenas"}</span></li>
                <li><span className="fw-light">{"Generalidades"}</span></li>
                <li><span className="fw-light">{"LSD"}</span></li>
                <li><span className="fw-light">{"Hongos y plantas alucinógenas"}</span></li>
                <li><span className="fw-light">{"Los alucinógenos según el manual diagnóstico y estadístico de los trastornos mentales"}</span></li>
            </ul>
            <br /><br />
            <b>{"Los inhalantes"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Solventes volátiles"}</span></li>
                <li><span className="fw-light">{"Generalidades"}</span></li>
                <li><span className="fw-light">{"Toxicidad aguda"}</span></li>
                <li><span className="fw-light">{"Toxicidad crónica"}</span></li>
                <li><span className="fw-light">{"Los inhalantes según el manual diagnóstico y estadístico de los trastornos mentales"}</span></li>
            </ul>
            <br /><br />
            <b>{"Los opiáceos y opioides"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Generalidades y clasificación"}</span></li>
                <li><span className="fw-light">{"Toxicidad aguda"}</span></li>
                <li><span className="fw-light">{"Dependencia y síndrome de abstinencia"}</span></li>
                <li><span className="fw-light">{"Los opiáceos según el manual diagnóstico y estadístico de los trastornos mentales"}</span></li>
                <li><span className="fw-light">{"Abordajes terapéuticos: desintoxicación, deshabituación y sustitución"}</span></li>
            </ul>
            <br /><br />
            <b>{"Sedantes, hipnóticos o ansiolíticos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Hipnosedantes: benzodiacepinas y otros hipnóticos"}</span></li>
                <li><span className="fw-light">{"Barbitúricos"}</span></li>
                <li><span className="fw-light">{"Intoxicación aguda"}</span></li>
                <li><span className="fw-light">{"Dependencia y síndrome de abstinencia"}</span></li>
                <li><span className="fw-light">{"Los sedantes según el manual diagnóstico y estadístico de los trastornos mentales"}</span></li>
            </ul>
            <br /><br />
            <b>{"Nuevas sustancias psicoactivas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Conceptos generales y clasificación"}</span></li>
                <li><span className="fw-light">{"Feniletilaminas de síntesis"}</span></li>
                <li><span className="fw-light">{"Estimulantes"}</span></li>
                <li><span className="fw-light">{"Arilciclohexilaminas"}</span></li>
                <li><span className="fw-light">{"Ketamina"}</span></li>
                <li><span className="fw-light">{"Cannabinoides sintéticos"}</span></li>
                <li><span className="fw-light">{"Opioides de síntesis"}</span></li>
            </ul>
            <br /><br />
            <b>{"La adicción tecnológica en menores, adolescentes y adultos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Adicción a las nuevas tecnologías"}</span></li>
                <li><span className="fw-light">{"Jóvenes y nuevas tecnologías"}</span></li>
                <li><span className="fw-light">{"Uso de las nuevas tecnologías por los adolescentes"}</span></li>
                <li><span className="fw-light">{"Adicción a las nuevas tecnologías en la etapa adulta"}</span></li>
            </ul>
            <br /><br />
            <b>{"Juego patológico o ludopatía"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Evolución histórica del juego patológico"}</span></li>
                <li><span className="fw-light">{"Conceptualización de la conducta patológica"}</span></li>
                <li><span className="fw-light">{"Criterios diagnósticos del juego patológico o ludopatía"}</span></li>
                <li><span className="fw-light">{"Características demográficas"}</span></li>
                <li><span className="fw-light">{"Tipos de jugadores"}</span></li>
                <li><span className="fw-light">{"Proceso de desarrollo de la conducta adictiva"}</span></li>
            </ul>
            <br /><br />
            <b>{"Gestión y evolución en adicciones"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Rehabilitación (etapas)"}</span></li>
                <li><span className="fw-light">{"Participación del contexto: familia, parejas, amigos y comunidad"}</span></li>
                <li><span className="fw-light">{"Recaídas y recidivas"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaMedicinaAdicciones;
